const normalizeStatus = (task) =>
  String(task?.taskStatus || "").trim().toLowerCase().replace(/\s+/g, "_");

const isStatus = (task, statuses) => statuses.includes(normalizeStatus(task));
const all = (tasks, statuses) =>
  Array.isArray(tasks) && tasks.length > 0 && tasks.every((task) => isStatus(task, statuses));
const some = (tasks, statuses) => Array.isArray(tasks) && tasks.some((task) => isStatus(task, statuses));

const ON_HOLD = ["on_hold", "onhold"];

// On Hold and Pending tasks can be assigned, reassigned and unassigned.
export const isOnHoldOrPending = (task) => isStatus(task, [...ON_HOLD, "pending"]);

// Assign: every selected task must be Active, Pending or On Hold. One Assigned
// task in the mix would otherwise be silently reassigned.
export const canAssignTasks = (tasks) => all(tasks, ["active", "pending", ...ON_HOLD]);

// Reassign (status part only -- Completed tasks are handled by canReassignTask
// in taskReassignRules, which keeps its unsuccessful-completed exception).
export const canReassignByStatus = (tasks) =>
  all(tasks, ["assigned", "in_progress", "pending", "completed", "finished", ...ON_HOLD]);

// Unassign: every selected task must be Assigned, Pending or On Hold.
export const canUnassignTasks = (tasks) => all(tasks, ["assigned", "pending", ...ON_HOLD]);

// On Hold is rejected for Completed / Finished, Pending and already On Hold tasks.
export const hasCompletedTask = (tasks) => some(tasks, ["completed", "finished"]);
export const hasPendingTask = (tasks) => some(tasks, ["pending"]);
export const hasOnHoldTask = (tasks) => some(tasks, ON_HOLD);
